// extracted by mini-css-extract-plugin
module.exports = {"filter-chip-indicators-item":"FilterChipIndicatorsItem_filter-chip-indicators-item__UAdVM"};